module.exports = __webpack_public_path__ + "img/file-circle-info.07e6c565.svg";